import axios from "./axios";
import qs from "qs";

export default {
  fetchReimbursements(params) {
    return axios.get("/node/fetchReimbursements", { params });
  },
  fetchReimbursementBusinessTypes(params) {
    return axios.get("/node/fetchReimbursementBusinessTypes", { params: params || {} });
  },
  addOrUpdateReimbursementBusinessType(data) {
    return axios.post("/node/addOrUpdateReimbursementBusinessType", qs.stringify(data));
  },
  deleteReimbursementBusinessType(data) {
    return axios.post("/node/deleteReimbursementBusinessType", qs.stringify(data));
  },
  addOrUpdateReimbursement(data) {
    return axios.post("/node/addOrUpdateReimbursement", qs.stringify(data));
  },
  updateReimbursementStatus(data) {
    return axios.post("/node/updateReimbursementStatus", qs.stringify(data));
  },
  updateReimbursementAttachment(data) {
    return axios.post("/node/updateReimbursementAttachment", qs.stringify(data));
  },
  voidReimbursement(data) {
    return axios.post("/node/voidReimbursement", qs.stringify(data));
  },
};
